export const pathToString = (array) => {
    return array.reduce((string, item) => {
        const prefix = string === '' ? '' : '.';
        return string + (Number.isNaN(Number(item)) ? prefix + item : `[${item}]`);
    }, '');
};
